'use client';

import styled from '@emotion/styled';
import { useEffect } from 'react';
import { configure } from 'utils/configure';

const useResponsiveImageMap = (imageId: string, mapName: string) => {
  useEffect(() => {
    const resizeMap = () => {
      const image = document.getElementById(imageId) as HTMLImageElement;
      if (!image) {
        return;
      }

      const map = document.querySelector(`map[name="${mapName}"]`) as HTMLMapElement;
      if (!map) {
        return;
      }

      const imageWidth = image.offsetWidth;
      const originalWidth = image.naturalWidth;
      const scale = imageWidth / originalWidth;

      map.querySelectorAll('area').forEach(area => {
        const originalCoords = area.dataset.originalCoords || area.getAttribute('coords');
        // eslint-disable-next-line no-param-reassign
        area.dataset.originalCoords = originalCoords || '';
        if (originalCoords) {
          const coords = originalCoords.split(',').map(coord => Math.round(parseInt(coord, 10) * scale));
          area.setAttribute('coords', coords.join(','));
        }
      });
    };

    window.addEventListener('resize', resizeMap);
    resizeMap(); // 초기 실행

    return () => {
      window.removeEventListener('resize', resizeMap);
    };
  }, [imageId, mapName]);
};

export default function Top7Page() {
  useResponsiveImageMap('contents', 'image-map-contents');
  useResponsiveImageMap('footer', 'image-map-footer');
  useResponsiveImageMap('top7', 'image-map-top7');

  return (
    <>
      <StyledImageWrapperTab>
        <StyledImage src={`${configure.staticPrefix}/images/promotions/play-pick-and-choo/top7/tab.png`} alt="" />
      </StyledImageWrapperTab>
      <StyledTopWrapper>
        <StyledImageWrapper>
          <StyledImage
            src={`${configure.staticPrefix}/images/promotions/play-pick-and-choo/top7/top-content.png`}
            alt=""
          />
        </StyledImageWrapper>
      </StyledTopWrapper>
      <StyledContentImageWrapper>
        <StyledImage src={`${configure.staticPrefix}/images/promotions/play-pick-and-choo/top7/top7-text.svg`} alt="" />
      </StyledContentImageWrapper>
      <StyledContentImageWrapper>
        <StyledImage
          src={`${configure.staticPrefix}/images/promotions/play-pick-and-choo/top7/top7.png`}
          alt=""
          id="top7"
          useMap="#image-map-top7"
        />
      </StyledContentImageWrapper>
      <map name="image-map-top7">
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2394095"
          coords="279,257,505,598"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2394155"
          coords="282,1038,502,1374"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2393557"
          coords="156,1949,380,2287"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2393911"
          coords="402,1950,623,2287"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2393826"
          coords="152,2451,382,2792"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2393900"
          coords="397,2453,624,2789"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2393664"
          coords="281,2955,502,3288"
          shape="rect"
        />
      </map>
      <StyledContentImageWrapper>
        <StyledImage
          src={`${configure.staticPrefix}/images/promotions/play-pick-and-choo/top7/top30.png`}
          alt=""
          id="contents"
          useMap="#image-map-contents"
        />
      </StyledContentImageWrapper>
      <map name="image-map-contents">
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2393350"
          coords="258,856,32,512"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2394032"
          coords="279,517,504,857"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2394173"
          coords="524,523,747,851"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2393965"
          coords="32,1048,259,1391"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2394155"
          coords="279,1053,503,1388"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2394160"
          coords="518,1049,747,1388"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2393406"
          coords="33,1584,259,1922"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2394107"
          coords="279,1583,503,1923"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2393557"
          coords="522,1585,745,1922"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2393702"
          coords="34,2114,260,2454"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2393514"
          coords="281,2117,504,2455"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2393354"
          coords="523,2117,749,2456"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2393521"
          coords="35,2650,255,2997"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2394117"
          coords="279,2652,500,2988"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2393794"
          coords="520,2648,747,2988"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2393772"
          coords="36,3186,257,3526"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2393911"
          coords="278,3184,503,3525"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2393826"
          coords="526,3190,745,3521"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2393839"
          coords="37,3720,257,4057"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2394114"
          coords="284,3725,501,4052"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2393433"
          coords="524,3719,747,4057"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2394020"
          coords="36,4252,260,4591"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2393900"
          coords="274,4252,503,4594"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2393446"
          coords="523,4253,747,4589"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2394012"
          coords="35,4789,253,5120"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2394113"
          coords="280,4787,503,5127"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2393664"
          coords="527,4790,748,5123"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2394095"
          coords="36,5323,258,5661"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2393757"
          coords="276,5321,503,5659"
          shape="rect"
        />
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://www.diritto.co.kr/contents/2393921"
          coords="522,5322,744,5658"
          shape="rect"
        />
      </map>
      <StyledContentImageWrapper>
        <StyledImage
          src={`${configure.staticPrefix}/images/promotions/play-pick-and-choo/top7/footer.png`}
          alt=""
          id="footer"
          useMap="#image-map-footer"
        />
      </StyledContentImageWrapper>
      <map name="image-map-footer">
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,jsx-a11y/no-static-element-interactions */}
        <area
          target=""
          alt=""
          title=""
          href="https://help.diritto.co.kr/hc/ko/articles/10018792549391-PLAY-%ED%94%BD%EC%95%A4%EC%B8%84-%ED%8C%90%ED%83%80%EC%A7%80-ONLY"
          coords="75,731,705,833"
          shape="rect"
        />
      </map>{' '}
    </>
  );
}

const StyledTopWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  width: 100%;
  background-image: url(${`${configure.staticPrefix}/images/promotions/play-pick-and-choo/vote/top-bg.png`});
  background-repeat: no-repeat;
  background-position: center top;

  @media (min-width: 915px) {
    background-size: 100%;
  }

  background-size: auto 100%;
`;

const StyledImageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
`;

const StyledContentImageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  background-color: #322e36;
`;

const StyledImageWrapperTab = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #a471ff;
`;

const StyledImage = styled.img`
  width: 100%;
  max-width: 390px;
  height: auto;
`;
